var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "div",
        { staticClass: "container content-padding bonus-container" },
        [
          _vm.isEditing
            ? [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12 text-center" }, [
                    _c("h2", { staticClass: "mt-5" }, [
                      _vm._v("ขออภัยในความไม่สะดวก")
                    ]),
                    _vm._v(" "),
                    _c("h3", [_vm._v(_vm._s(_vm.editingRemark))])
                  ])
                ])
              ]
            : [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("div", { staticClass: "bonus-card" }, [
                      _c("div", { staticClass: "bonus-header" }, [
                        _vm._m(1),
                        _vm._v(" "),
                        _c("div", { staticClass: "bonus-header-icon" }, [
                          _c("i", {
                            staticClass: "fal fa-exclamation-circle alert-icon",
                            on: { click: _vm.openDescModal }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _vm._m(2),
                      _vm._v(" "),
                      _c("div", { staticClass: "bonus-hours" }, [
                        _c("p", { staticClass: "bonus-total-hours" }, [
                          _vm._v(_vm._s(_vm.hours) + " ชั่วโมง")
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "bonus-hours-desc" }, [
                          _vm._v("ชั่วโมงที่คุณสะสมได้ในกิจกรรมนี้ "),
                          _c(
                            "span",
                            { staticClass: "bonus-hours-desc-detail" },
                            [_vm._v("(จาก " + _vm._s(_vm.orderQty) + " งาน)")]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _vm.getCurrentBonusIndex() === _vm.bonuses.length - 1
                        ? _c("div", { staticClass: "bonus-progress-final" }, [
                            _vm._m(3)
                          ])
                        : _c("div", { staticClass: "bonus-progress" }, [
                            _c("p", [
                              _vm._v("\n                สะสมอีก "),
                              _c(
                                "span",
                                { staticClass: "bonus-progress-highlight" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.getNextHoursFromCurrentHours())
                                  )
                                ]
                              ),
                              _vm._v(" ชั่วโมง \n                "),
                              _vm.getCurrentBonusIndex() === -1
                                ? _c("span", [_vm._v("เพื่อรับโบนัสจากเรา")])
                                : _c("span", [
                                    _vm._v(" อัพเกรดโบนัสเป็น "),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "bonus-progress-highlight"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getNextBonus()
                                              ? _vm.getNextBonus().short_title
                                              : "-"
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" บาท")
                                  ])
                            ])
                          ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "bonus-progress-bar" }, [
                        _c(
                          "div",
                          { staticClass: "progress-track" },
                          [
                            _c("div", { staticClass: "progress-bg" }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "progress-waiting",
                              style: {
                                width:
                                  _vm.calculateHourPercentage(
                                    _vm.unConfirmedHours
                                  ) + "%"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "progress-confirmed",
                              style: {
                                width:
                                  _vm.calculateHourPercentage(_vm.hours) + "%"
                              }
                            }),
                            _vm._v(" "),
                            _vm._m(4),
                            _vm._v(" "),
                            _vm._l(_vm.bonuses, function(bonus, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "reward-point",
                                  style: { left: bonus.percentage + "%" }
                                },
                                [
                                  _vm.isBonusVisible(index)
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "reward-label",
                                            class: {
                                              "reward-label-active": _vm.isCurrentBonus(
                                                index
                                              ),
                                              "reward-label-final":
                                                index === _vm.bonuses.length - 1
                                            }
                                          },
                                          [_vm._v(_vm._s(bonus.short_title))]
                                        ),
                                        _vm._v(" "),
                                        _c("img", {
                                          staticClass: "reward-icon",
                                          attrs: { src: bonus.icon }
                                        })
                                      ]
                                    : _vm._e()
                                ],
                                2
                              )
                            })
                          ],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _vm._m(5)
                    ])
                  ])
                ]),
                _vm._v(" "),
                _vm._m(6),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c(
                      "div",
                      { staticClass: "bonus-detail" },
                      [
                        _c("div", { staticClass: "bonus-detail-title" }, [
                          _vm._v(
                            "\n              รายละเอียดโบนัส\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.bonuses, function(bonus, index) {
                          return [
                            _vm.isBonusVisible(index)
                              ? _c(
                                  "div",
                                  {
                                    key: "bonus-card-" + index,
                                    staticClass: "bonus-detail-card",
                                    class: {
                                      "bonus-detail-card-active":
                                        _vm.isCurrentBonus(index) &&
                                        index !== _vm.bonuses.length - 1,
                                      "bonus-detail-card-active-final":
                                        _vm.isCurrentBonus(index) &&
                                        index === _vm.bonuses.length - 1
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.showBonusDetail(index)
                                      }
                                    }
                                  },
                                  [
                                    _vm._m(7, true),
                                    _vm._v(" "),
                                    _c("div", [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "bonus-detail-card-title"
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(bonus.title) +
                                              "\n                  "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "bonus-detail-card-content"
                                        },
                                        [
                                          _vm._v(
                                            "\n                    เมื่อรับงานครบ "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bonus-detail-card-content-highlight"
                                            },
                                            [_vm._v(_vm._s(bonus.hours))]
                                          ),
                                          _vm._v(" ชั่วโมง\n                  ")
                                        ]
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isNextBonusVisible(index)
                              ? _c(
                                  "div",
                                  {
                                    key: "bonus-card-next-" + index,
                                    staticClass: "bonus-detail-card-next"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "bonus-detail-card-next-title"
                                      },
                                      [
                                        _vm._v(
                                          "\n                  สะสมเพิ่มอีก "
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "bonus-detail-card-next-title-highlight"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getNextHoursFromCurrentHours()
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" ชั่วโมง เพื่ออัปเกรด"),
                                        _c("br"),
                                        _vm._v("โบนัสเป็น "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "bonus-detail-card-next-title-highlight"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getNextBonus()
                                                  ? _vm.getNextBonus()
                                                      .short_title
                                                  : "-"
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" บาท\n                ")
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._m(8, true)
                                  ]
                                )
                              : _vm._e()
                          ]
                        })
                      ],
                      2
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm._m(9)
              ]
        ],
        2
      ),
      _vm._v(" "),
      _c("sweet-modal", { ref: "descModal" }, [
        _c("div", { staticClass: "bonus-desc" }, [
          _c("div", { staticClass: "bonus-desc-title" }, [
            _vm._v("\n        คำอธิบายรายละเอียด\n      ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "bonus-desc-icon" }, [
            _c("img", {
              attrs: {
                src:
                  "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/bonus/target.gif",
                alt: "bonus-target"
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "bonus-desc-content" }, [
            _c("div", { staticClass: "bonus-desc-content-title" }, [
              _vm._v("\n          เริ่มอ่านคำอธิบายกัน\n        ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "bonus-desc-content-text" }, [
              _c("img", {
                attrs: {
                  src:
                    "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/bonus/desc-1.svg",
                  alt: "bonus-desc-1"
                }
              }),
              _vm._v(" "),
              _c("span", [
                _vm._v("คุณแม่บ้านสะสมชั่วโมงให้ครบ เพื่อรับโบนัสจาก BeNeat")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "bonus-desc-content-text" }, [
              _c("img", {
                attrs: {
                  src:
                    "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/bonus/desc-2.svg",
                  alt: "bonus-desc-2"
                }
              }),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "คุณแม่บ้านจะได้รับการโอนเงินโบนัสตามรอบโอนเงินสัปดาห์ที่ประกาศผล หรือส่งรางวัลโบนัสรอบสัปดาห์ถัดไปหลังจากประกาศผล"
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "bonus-desc-content-text" }, [
              _c("img", {
                attrs: {
                  src:
                    "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/bonus/desc-3.svg",
                  alt: "bonus-desc-3"
                }
              }),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "หากคุณแม่บ้าน สะสมชั่วโมงไม่ครบ ตามที่ทางเรากำหนดไว้จะถือว่าไม่ผ่านเกณฑ์การรับรางวัลของ BeNeat"
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "bonus-desc-content-text" }, [
              _c("img", {
                attrs: {
                  src:
                    "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/bonus/desc-4.svg",
                  alt: "bonus-desc-4"
                }
              }),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "การนับชั่วโมงการทำงานเฉพาะงานที่เข้าให้บริการและกดเสร็จงานระหว่างวันที่ 1 - 31 ก.ค. 2568 และต้องไม่มีการแจ้งปัญหา"
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "bonus-desc-progress-bar-card" }, [
            _c("div", { staticClass: "bonus-desc-progress-bar-title" }, [
              _vm._v("\n          อธิบายแถบสถานะ\n        ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "bonus-desc-progress-bar-img" }, [
              _c("img", {
                attrs: {
                  src:
                    "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/bonus/example-bar-1.svg",
                  alt: "example-bar-1"
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "bonus-desc-progress-bar-text" }, [
              _c("div", { staticClass: "bonus-desc-progress-bar-text-item" }, [
                _c("span", {
                  staticClass: "bonus-desc-progress-bar-text-item-confirmed"
                }),
                _c("span", [_vm._v("คือ งานที่เสร็จแล้ว")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "bonus-desc-progress-bar-text-item" }, [
                _c("span", {
                  staticClass: "bonus-desc-progress-bar-text-item-unconfirmed"
                }),
                _c("span", [_vm._v("คือ งานที่ยังไม่เข้าให้บริการ")])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "bonus-desc-progress-bar-card" }, [
            _c("div", { staticClass: "bonus-desc-progress-bar-title" }, [
              _vm._v("\n          การได้รับโบนัส\n        ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "bonus-desc-progress-bar-img" }, [
              _c("img", {
                attrs: {
                  src:
                    "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/bonus/example-bar-2.svg",
                  alt: "example-bar-2"
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "bonus-desc-progress-bar-text" }, [
              _c("span", [
                _vm._v("คุณจะได้รับรางวัลเฉพาะระดับสูงสุดที่ทำครบเท่านั้น"),
                _c("br"),
                _vm._v("ไม่ใช่รางวัลสะสมทุกระดับ")
              ])
            ])
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12 text-center" }, [
        _c("h2", { staticClass: "bonus-title" }, [
          _vm._v("เก็บงานเพลิน รับเงินปัง!!")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bonus-header-title" }, [
      _c("p", [_vm._v("สถานะของฉัน")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bonus-target" }, [
      _c("img", {
        attrs: {
          src:
            "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/bonus/target.gif",
          alt: "bonus-target"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("span", [_vm._v("ยินดีด้วยคุณได้รับโบนัสใหญ่")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "reward-point reward-point-start" }, [
      _c("img", {
        staticClass: "reward-icon",
        attrs: {
          src:
            "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/bonus/clean-up.gif",
          alt: "icon"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bonus-duration" }, [
      _c("p", [_vm._v("ตั้งแต่วันที่ 1 - 31 กรกฎาคม 2568")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("div", { staticClass: "bonus-warning-card" }, [
          _c("div", { staticClass: "bonus-warning-card-icon" }, [
            _c("img", {
              attrs: {
                src:
                  "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/bonus/warning.svg",
                alt: "bonus-warning"
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "bonus-warning-card-label" }, [
            _c("p", [
              _vm._v("คุณจะได้รับรางวัลเฉพาะระดับสูงสุดที่ทำครบเท่านั้น"),
              _c("br"),
              _vm._v("ไม่ใช่รางวัลสะสมทุกระดับ")
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bonus-detail-card-icon" }, [
      _c("img", {
        attrs: {
          src:
            "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/bonus/voucher.svg",
          alt: "bonus-voucher"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bonus-detail-card-next-icon" }, [
      _c("img", {
        attrs: {
          src:
            "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/bonus/arrow.gif",
          alt: "bonus-arrow"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("div", { staticClass: "bonus-terms" }, [
          _c("div", { staticClass: "bonus-terms-title" }, [
            _vm._v("\n              ข้อกำหนดและเงื่อนไข\n            ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "bonus-terms-content" }, [
            _c("ul", [
              _c("li", [
                _vm._v(
                  "การนับชั่วโมงการทำงานเฉพาะงานที่เข้าให้บริการและกดเสร็จงาน ระหว่างวันที่ 1 - 31 ก.ค. 2568 และต้องไม่มีการแจ้งปัญหา"
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "โบนัสจะโอนพร้อมรอบรายได้คุณแม่บ้านในวันที่ 7 ส.ค. 68 และน้ำยา BeNeat และ BeShine จะดำเนินการจัดส่งภายในวันที่ 15 ส.ค. 68"
                )
              ]),
              _vm._v(" "),
              _c("li", [_vm._v("ทางบริษัทจะทำการหัก ณ ที่จ่าย 3% จากยอดโบนัส")])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-617c74dc", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-617c74dc","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/professional/ProfessionalBonusV2.vue
// module id = 1985
// module chunks = 0